import { isABN, isACN, isUUID } from '__core/shared/util/validate';
import template from './contact.template.html';
import templateTesseract from '../integrations/tesseract/ocrDocument.template.html';
import templateUploadAvatar from '../contact/contactUploadAvatar.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    contact: '<',
    contacts: '<',
    spouses: '<',
    countries: '<',
    occupations: '<',
    industries: '<',
    outboundReferrers: '<',
    validationErrors: '<',
    isFactFind: '<',
    workflow: '<',
    ticket: '<',
    ticketOwner: '<',
    ticketAttachments: '<',
    addresses: '<',
    documents: '<',
    isTicketSettled: '<',
    onFinished: '&',
    onClientsFinished: '&',
    onIncomeFinished: '&',
    onAssetFinished: '&',
    onDiversificationFinished: '&',
    onDiversificationIntegrationFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $sce,
      $rootScope,
      $timeout,
      $http,
      $mdMedia,
      $mdUtil,
      $mdDialog,
      $mdMenu,
      eventService,
      helperService,
      Address,
      Contact,
      contactService,
      contactsService,
      Dependent,
      dateTimeService,
      CompanyIndividual,
      Employment,
      Asset,
      AssetType,
      assetsService,
      incomeService,
      OpportunityContextualType,
      diversificationOpportunityService,
      ContactCompanyType,
      ContactCompanyTrustStructure,
      ContactDriverLicenceType,
      ContactEmploymentType,
      ContactGender,
      ContactMaritalStatusOption,
      ContactMedicareCardColor,
      ContactNextOfKinRelationship,
      ContactPersonalReferenceRelationship,
      ContactResidencyStatusOption,
      ContactResidentialStatusOption,
      ContactSourceOfWealth,
      PersonalTitle,
      dataService,
      uiService,
      INSTANCE,
      CONTACT,
      GOOGLEMAPS,
      ABNLookupService,
      NZBNLookupService,
      fileService
    ) {
      'ngInject';

      /*
       * Controller model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.mdMenu = $mdMenu;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.organizationCountry = '';
      ctrl.googleAutocompleteOptions = {};
      ctrl.availableStates = [];
      ctrl.availablePersonalTitles = [];
      ctrl.availableContactGenders = [];
      ctrl.availableContactMaritalStatusOptions = [];
      ctrl.availableContactDriverLicenceTypes = [];
      ctrl.availableContactMedicareCardColors = [];
      ctrl.availableContactNextOfKinRelationships = [];
      ctrl.availableContactPersonalReferenceRelationships = [];
      ctrl.availableContactResidencyStatusOptions = [];
      ctrl.availableHousing = [];
      ctrl.availableContactCompanyTypes = [];
      ctrl.availableContactCompanyTrustStructures = [];
      ctrl.availableContactSourceOfWealths = [];
      ctrl.spouseContacts = [];
      ctrl.availableAssetTypes = [];
      ctrl.incomeTypesAvailable = [];
      ctrl.otherDateFormat = $rootScope.CurrentDateFormatSecondary();
      ctrl.dateFormat = helperService.setOtherDateFormat;
      ctrl.phoneValidationMessage_primary = '';
      ctrl.phoneValidationMessage_home = '';
      ctrl.phoneValidationMessage_work = '';
      ctrl.phoneValidationMessage_company = '';
      ctrl.phoneValidationMessage_fax = '';
      ctrl.personEmailValidationMessage = '';
      ctrl.personEmail2ValidationMessage = '';
      ctrl.companyEmailValidationMessage = '';
      ctrl.searchIndustryCode = '';
      ctrl.isDev = $rootScope.isDev();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.organizationCountryCCA2 = helperService.getOrganizationCountry().cca2;
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availablePersonalTitles = PersonalTitle.available();
        ctrl.availableContactGenders = ContactGender.available();
        ctrl.availableContactMaritalStatusOptions = ContactMaritalStatusOption.available();
        ctrl.availableContactDriverLicenceTypes = ContactDriverLicenceType.available();
        ctrl.availableContactMedicareCardColors = ContactMedicareCardColor.available();
        ctrl.availableContactNextOfKinRelationships = ContactNextOfKinRelationship.available();
        ctrl.availableContactPersonalReferenceRelationships =
          ContactPersonalReferenceRelationship.available();
        ctrl.availableContactResidencyStatusOptions = ContactResidencyStatusOption.available();
        ctrl.availableContactResidentialStatusOptions =
          ContactResidentialStatusOption.available();
        ctrl.availableContactCompanyTypes = ContactCompanyType.available();
        ctrl.availableContactCompanyTrustStructures = ContactCompanyTrustStructure.available();
        ctrl.availableContactSourceOfWealths = ContactSourceOfWealth.available();
        if (ctrl.isFactFind) {
          ctrl.availableAssetTypes = assetsService.getAvailableAssetTypes();
          ctrl.incomeTypesAvailable = incomeService.getAvailableIncomeTypes();
        }
        ctrl.contact = ctrl.contact || {};

        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'person.information.dateOfBirth',
          'getSetDateOfBirth'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'company.information.incorporated',
          'getSetIncorporated'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'company.information.dateOfRegistration',
          'getSetDateOfRegistration'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'company.information.vatRegisteredDate',
          'getSetVatRegisteredDate'
        );
        dateTimeService.getSet(ctrl, ctrl.contact, 'person.contact.from', 'getSetAddressFrom');
        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'person.contact.previousFrom',
          'getSetPreviousAddressFrom'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'person.information.driversLicenseExpiryDate',
          'getSetDriversLicenseExpiryDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'person.information.passportIssueDate',
          'getSetPassportIssueDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'person.information.passportExpiryDate',
          'getSetPassportExpiryDate'
        );
        dateTimeService.getSet(
          ctrl,
          ctrl.contact,
          'person.information.medicareExpiryDate',
          'getSetMedicareExpiryDate'
        );
        if (
          ctrl.contact?.isCompany &&
          (!ctrl.contact?.company?.information?.industryCode?.id ||
            !ctrl.contact?.company?.information?.industryCode?.value)
        ) {
          ctrl.contact.company.information.industryCode = null;
        }
        ctrl.contacts = ctrl.contacts || [];
        ctrl.spouses = ctrl.spouses || [];
        ctrl.personContacts = _.filter(ctrl.contacts, (c) => !c.isCompany).concat(ctrl.spouses);
        ctrl.countries = ctrl.countries || [];
        ctrl.occupations = ctrl.occupations || [];
        ctrl.industries = ctrl.industries || [];
        ctrl.outboundReferrers = ctrl.outboundReferrers || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.isFactFind = ctrl.isFactFind || false;
        ctrl.workflow = ctrl.workflow || {};
        ctrl.ticket = ctrl.ticket || {};
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.addresses = ctrl.addresses || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isSpouseInactive = false;
        ctrl.isSpouseDeleted = false;
        ctrl.spouseContact = null;
        ctrl.getSpouse();

        ctrl.ticketAttachments =
          _.filter(ctrl.ticketAttachments, (a) => {
            const ext = a.getFileExtension();
            if (ext) {
              return (
                ext.toLowerCase() === 'jpeg' ||
                ext.toLowerCase() === 'jpg' ||
                ext.toLowerCase() === 'png' ||
                ext.toLowerCase() === 'pdf'
              );
            }
            return false;
          }) || [];
        ctrl.ticketAttachmentsDriversLicense = _.filter(
          ctrl.ticketAttachments,
          (t) =>
            t.name.toLowerCase().indexOf('driver') > -1 ||
            t.name.toLowerCase().indexOf('license') > -1
        );
        ctrl.ticketAttachmentsPassport = _.filter(
          ctrl.ticketAttachments,
          (t) => t.name.toLowerCase().indexOf('passport') > -1
        );
        ctrl.ticketAttachmentsMedicare = _.filter(
          ctrl.ticketAttachments,
          (t) => t.name.toLowerCase().indexOf('medicare') > -1
        );
        ctrl.setSpouseContacts();
        if (!ctrl?.contact?.isCompany) {
          ctrl.setDependentDate();
        }
        ctrl.setDiversificationOpportunities();
        ctrl.isReady = true;
      };

      /*
       * Upload avatar
       * --------------------------------------------------------------------------------
       */
      ctrl.uploadAvatar = ($event) => {
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              contact: ctrl.contact
            },
            template: templateUploadAvatar,
            controllerAs: '$ctrl',
            controller(contact) {
              this.url = CONTACT.API.UPLOAD;
              this.allowMultiple = CONTACT.LIMITS.MULTIPLE;
              this.allowedMimeTypes = CONTACT.LIMITS.ALLOWED_MIME;
              this.allowedExtensions = CONTACT.LIMITS.ALLOWED_EXTENSIONS;
              this.minimumWidth = CONTACT.LIMITS.MIN_WIDTH;
              this.minimumHeight = CONTACT.LIMITS.MIN_HEIGHT;
              this.aspectRatio = CONTACT.LIMITS.ASPECT_RATIO;
              this.contact = contact;
              this.idContact = this.contact.id;

              this.uploadFinished = () => {
                $mdDialog.hide(this.contact);
              };
              this.confirm = () => {
                this.startUpload = true;
              };
              this.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            const contact = result;
            $timeout(() => {
              if (
                contact.getAvatar() !==
                `${INSTANCE.cdn}/avatars/contacts/${ctrl.currentOrganization.id}/${contact.id}.png`
              ) {
                contact.avatar = `${INSTANCE.cdn}/avatars/contacts/${ctrl.currentOrganization.id}/${contact.id}.png`;
              }
              ctrl.saveContact();
              $timeout(() => {
                eventService.accountAvatarUploaded();
              }, 250);
            });
          });
      };

      ctrl.marketingToggle = () => {
        eventService.confirmDialog({
          event: null,
          alert: {
            messages: [
              'Marketing opt-in option will be permanently changed to "off" and can no longer be changed.'
            ],
            icon: 'error',
            type: 'warning',
            isShowing: true
          },
          organizationName: ctrl.currentOrganization?.organization?.name || '-'
        });
      };

      ctrl.marketingToggled = (status) => {
        if (status) {
          ctrl.saveContact();
        } else {
          ctrl.contact.isMarketing = true;
        }
      };

      /*
       * OCR
       * --------------------------------------------------------------------------------
       */
      ctrl.tesseract = ($event, documentType, attachment) => {
        const showTesseract = () => {
          $mdDialog
            .show({
              targetEvent: $event,
              locals: {
                availableContactGenders: ctrl.availableContactGenders || [],
                countries: ctrl.countries || [],
                isDisabled: ctrl.isTicketSettled
              },
              template: templateTesseract,
              controllerAs: '$ctrl',
              controller(availableContactGenders, countries, isDisabled) {
                const self = this;
                self.isReady = false;
                self.isSaveEnabled = false;
                self.hasError = false;
                self.attachment = attachment;
                self.documentType = documentType;
                self.availableContactGenders = availableContactGenders;
                self.countries = countries;
                self.isDisabled = isDisabled;
                self.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
                self.currentTimeZone = $rootScope.CurrentTimeZone();
                self.ocrModel = {
                  id: '',
                  address: '',
                  avatar: '',
                  firstName: '',
                  lastName: '',
                  middleName: '',
                  dateOfBirth: 0,
                  gender: '',
                  expirationDate: 0,
                  issuedDate: 0,
                  issuer: '',
                  nationality: ''
                };
                self.imagePreview = '';

                self.getSetDateOfBirth = function (date) {
                  if (arguments.length) {
                    if (arguments[0] !== null) {
                      if (!self.ocrModel.dateOfBirth) {
                        self.ocrModel.dateOfBirthObject = '';
                      }
                      const dateOfBirthObject = dateTimeService.setDate(
                        date,
                        $rootScope.CurrentTimeZone(),
                        true
                      );
                      self.ocrModel.dateOfBirthObject = date;
                      self.ocrModel.dateOfBirth = moment
                        .utc(dateOfBirthObject)
                        .startOf('day')
                        .format('X');
                    } else {
                      self.ocrModel.dateOfBirthObject = date;
                      self.ocrModel.dateOfBirth = 0;
                    }
                  }
                  if (!self.ocrModel.dateOfBirthObject) {
                    if (self.ocrModel.dateOfBirth) {
                      const dateOfBirthObject = dateTimeService.setDate(
                        self.ocrModel.dateOfBirth,
                        $rootScope.CurrentTimeZone(),
                        false
                      );
                      self.ocrModel.dateOfBirthObject = dateOfBirthObject;
                    } else {
                      self.ocrModel.dateOfBirthObject = '';
                    }
                  }
                  return self.ocrModel.dateOfBirthObject;
                };
                self.getSetExpirationDate = function (date) {
                  if (arguments.length) {
                    if (arguments[0] !== null) {
                      if (!self.ocrModel.expirationDate) {
                        self.ocrModel.expirationDateObject = '';
                      }
                      const expirationDateObject = dateTimeService.setDate(
                        date,
                        $rootScope.CurrentTimeZone(),
                        true
                      );
                      self.ocrModel.expirationDateObject = date;
                      self.ocrModel.expirationDate = moment
                        .utc(expirationDateObject)
                        .startOf('day')
                        .format('X');
                    } else {
                      self.ocrModel.expirationDateObject = date;
                      self.ocrModel.expirationDate = 0;
                    }
                  }
                  if (!self.ocrModel.expirationDateObject) {
                    if (self.ocrModel.expirationDate) {
                      const expirationDateObject = dateTimeService.setDate(
                        self.ocrModel.expirationDate,
                        $rootScope.CurrentTimeZone(),
                        false
                      );
                      self.ocrModel.expirationDateObject = expirationDateObject;
                    } else {
                      self.ocrModel.expirationDateObject = '';
                    }
                  }
                  return self.ocrModel.expirationDateObject;
                };
                self.getSetIssuedDate = function (date) {
                  if (arguments.length) {
                    if (arguments[0] !== null) {
                      if (!self.ocrModel.issuedDate) {
                        self.ocrModel.issuedDateObject = '';
                      }
                      const issuedDateObject = dateTimeService.setDate(
                        date,
                        $rootScope.CurrentTimeZone(),
                        true
                      );
                      self.ocrModel.issuedDateObject = date;
                      self.ocrModel.issuedDate = moment
                        .utc(issuedDateObject)
                        .startOf('day')
                        .format('X');
                    } else {
                      self.ocrModel.issuedDateObject = date;
                      self.ocrModel.issuedDate = 0;
                    }
                  }
                  if (!self.ocrModel.issuedDateObject) {
                    if (self.ocrModel.issuedDate) {
                      const issuedDateObject = dateTimeService.setDate(
                        self.ocrModel.issuedDate,
                        $rootScope.CurrentTimeZone(),
                        false
                      );
                      self.ocrModel.issuedDateObject = issuedDateObject;
                    } else {
                      self.ocrModel.issuedDateObject = '';
                    }
                  }
                  return self.ocrModel.issuedDateObject;
                };

                if (attachment.file) {
                  $q.all([
                    dataService.apiRequest(
                      null,
                      null,
                      true,
                      null,
                      $http.get,
                      '/api/v1/integration/documents/ocr/upload',
                      {
                        params: {
                          isNote: attachment.idNote && attachment.idNote !== '',
                          file: attachment.file,
                          documentType
                        }
                      },
                      ['file'],
                      false
                    ),
                    fileService.preview({
                      file: attachment?.file,
                      type: attachment?.idNote ? 'notes' : 'deals'
                    })
                  ])
                    .then((data) => {
                      const ocrData = data[0];
                      self.imagePreview = data[1]?.results[0]?.imageLarge || '';

                      if (!ocrData || (ocrData && !ocrData.id)) {
                        $timeout(() => {
                          self.hasError = true;
                          self.isReady = true;
                        });
                      } else {
                        self.ocrModel.id = ocrData?.id || '';
                        self.ocrModel.address = ocrData?.address || '';
                        self.ocrModel.avatar = ocrData?.avatar || '';
                        self.ocrModel.firstName = ocrData?.firstName || '';
                        self.ocrModel.lastName = ocrData?.lastName || '';
                        self.ocrModel.middleName = ocrData?.middleName || '';
                        self.ocrModel.dateOfBirth = ocrData?.dateOfBirth || 0;
                        self.ocrModel.gender = ContactGender.of(
                          ocrData?.gender?.toLowerCase() || ''
                        );
                        self.ocrModel.expirationDate = ocrData?.expirationDate || 0;
                        self.ocrModel.issuedDate = ocrData?.issuedDate || 0;
                        self.ocrModel.issuer = ocrData?.issuer || '';
                        self.ocrModel.nationality = ocrData?.nationality || '';
                        $timeout(() => {
                          self.isReady = true;
                          self.isSaveEnabled = true;
                        }, 500);
                      }
                    })
                    .catch((err) => {
                      $timeout(() => {
                        self.hasError = true;
                        self.isReady = true;
                      });
                    });
                } else {
                  self.isReady = true;
                }
                self.docType = documentType;

                self.confirm = () => {
                  if (self.isSaveEnabled) {
                    $mdDialog.hide(self.ocrModel);
                  }
                };
                self.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              let saveChanges = false;
              $timeout(() => {
                if (result?.gender) {
                  ctrl.contact.person.information.gender = result.gender;
                  saveChanges = true;
                }
                if (result?.dateOfBirth && ctrl.contact.person.information.dateOfBirth === 0) {
                  ctrl.contact.person.information.dateOfBirth = result.dateOfBirth;
                  saveChanges = true;
                  dateTimeService.getSet(
                    ctrl,
                    ctrl.contact,
                    'person.information.dateOfBirth',
                    'getSetDateOfBirth',
                    true
                  );
                }
                switch (documentType) {
                  case 'driverslicence':
                    ctrl.contact.person.information.driversLicenseNumber = result?.id || '';
                    if (result?.middleName) {
                      ctrl.contact.person.information.driversLicenseNameOnDocument = `${
                        result?.firstName || ''
                      } ${result?.middleName || ''} ${result?.lastName || ''}`;
                    } else {
                      ctrl.contact.person.information.driversLicenseNameOnDocument = `${
                        result?.firstName || ''
                      } ${result?.lastName || ''}`;
                    }
                    ctrl.contact.person.information.driversLicenseStateOfIssue = result?.issuer;
                    if (result?.expirationDate) {
                      ctrl.contact.person.information.driversLicenseExpiryDate =
                        result.expirationDate;
                      dateTimeService.getSet(
                        ctrl,
                        ctrl.contact,
                        'person.information.driversLicenseExpiryDate',
                        'getSetDriversLicenseExpiryDate',
                        true
                      );
                    }
                    if (
                      !Address.hasAddress(ctrl.contact.person.contact.address) &&
                      result?.address
                    ) {
                      if (result?.issuedDate) {
                        ctrl.contact.person.contact.address.formatted = result.address;
                        ctrl.contact.person.contact.from = result.issuedDate;
                        dateTimeService.getSet(
                          ctrl,
                          ctrl.contact,
                          'person.contact.from',
                          'getSetAddressFrom',
                          true
                        );
                      }
                    }
                    saveChanges = true;
                    break;
                  case 'passport':
                    if (result?.id) {
                      ctrl.contact.person.information.passportNumber = result.id;
                    }
                    if (result?.middleName) {
                      ctrl.contact.person.information.passportNameOnDocument = `${
                        result?.firstName || ''
                      } ${result?.middleName || ''} ${result?.lastName || ''}`;
                    } else {
                      ctrl.contact.person.information.passportNameOnDocument = `${
                        result?.firstName || ''
                      } ${result?.lastName || ''}`;
                    }
                    if (result?.issuer) {
                      ctrl.contact.person.information.passportIssueCountry = result.issuer;
                    }
                    if (result?.issuedDate) {
                      ctrl.contact.person.information.passportIssueDate = result.issuedDate;
                      dateTimeService.getSet(
                        ctrl,
                        ctrl.contact,
                        'person.information.passportIssueDate',
                        'getSetPassportIssueDate',
                        true
                      );
                    }
                    if (result?.expirationDate) {
                      ctrl.contact.person.information.passportExpiryDate =
                        result.expirationDate;
                      dateTimeService.getSet(
                        ctrl,
                        ctrl.contact,
                        'person.information.passportExpiryDate',
                        'getSetPassportExpiryDate',
                        true
                      );
                    }
                    if (result?.avatar && !ctrl.contact.getAvatar()) {
                      dataService.apiRequest(
                        null,
                        null,
                        true,
                        null,
                        $http.get,
                        '/api/v1/integration/documents/ocr/avatar',
                        {
                          params: {
                            idContact: ctrl.contact.id,
                            file: result.avatar
                          }
                        },
                        ['idContact', 'file'],
                        false
                      );
                    }
                    saveChanges = true;
                    break;
                  case 'medicare':
                    if (result?.id) {
                      ctrl.contact.person.information.medicareNumber = result.id;
                    }
                    // ctrl.contact.person.information.medicareReferenceNumber =
                    //   result.referenceNumber;
                    if (result?.middleName !== '') {
                      ctrl.contact.person.information.medicareNameOnCard = `${result.firstName} ${result.middleName} ${result.lastName}`;
                    } else {
                      ctrl.contact.person.information.medicareNameOnCard = `${result.firstName} ${result.lastName}`;
                    }
                    if (result?.expirationDate) {
                      ctrl.contact.person.information.medicareExpiryDate =
                        result.expirationDate;
                      dateTimeService.getSet(
                        ctrl,
                        ctrl.contact,
                        'person.information.medicareExpiryDate',
                        'getSetMedicareExpiryDate',
                        true
                      );
                    }
                    saveChanges = true;
                    break;
                  default:
                }
                if (saveChanges === true) {
                  ctrl.saveContact();
                }
              });
            });
        };
        showTesseract();
      };

      /*
       * Diversification opportunities
       * --------------------------------------------------------------------------------
       */
      ctrl.isSelfEmployedCurrentEmployment = () =>
        _.some(
          ctrl?.contact?.person?.employments,
          (e) => e?.isCurrent && e?.type?.name === ContactEmploymentType.self_employed.name
        );

      ctrl.setDiversificationOpportunities = () => {
        if (
          !ctrl.contact?.isCompany &&
          ctrl.contact?.id === ctrl.personContacts[0]?.id &&
          ctrl.isFactFind
        ) {
          if (
            ctrl.contact?.person?.employments?.length &&
            ctrl.isSelfEmployedCurrentEmployment()
          ) {
            ctrl.selfEmployedInvoiceFinance =
              OpportunityContextualType.self_employed_invoice_finance;
            ctrl.selfEmployedIndemnityCover =
              OpportunityContextualType.self_employed_indemnity_cover;
          } else {
            const idxFinance =
              diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                {
                  diversificationOpportunities: ctrl.ticket.diversificationOpportunities,
                  typeContextual: OpportunityContextualType.self_employed_invoice_finance
                }
              );
            if (idxFinance > -1) {
              ctrl.ticket.diversificationOpportunities.splice(idxFinance, 1);
            }
            const idxCover =
              diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                {
                  diversificationOpportunities: ctrl.ticket.diversificationOpportunities,
                  typeContextual: OpportunityContextualType.self_employed_indemnity_cover
                }
              );
            if (idxCover > -1) {
              ctrl.ticket.diversificationOpportunities.splice(idxCover, 1);
            }
          }
          ctrl.saveDiversificationOpportunities(ctrl.ticket.diversificationOpportunities);
        }
      };

      /*
       * Set Calling Code
       * --------------------------------------------------------------------------------
       */
      ctrl.setCallingCode = () => {
        let country = ctrl.contact.isCompany
          ? ctrl.contact.company.information.countryOfResidency
          : ctrl.contact.person.information.countryOfResidency;
        country =
          country !== '' ? ctrl.currentOrganization.organization.location.name.common : country;
        if (country !== '') {
          const code = ctrl.countries.find((c) => c.name && c.name.common === country);
          if (code !== undefined) {
            if (ctrl.contact.isCompany) {
              ctrl.contact.company.contact.phoneCode =
                ctrl.contact.company.contact.phone === ''
                  ? code.callingCode[0]
                  : ctrl.contact.company.contact.phoneCode;
              ctrl.contact.company.contact.faxCode =
                ctrl.contact.company.contact.fax === ''
                  ? code.callingCode[0]
                  : ctrl.contact.company.contact.faxCode;
            } else {
              ctrl.contact.person.contact.primaryCode =
                ctrl.contact.person.contact.primary === ''
                  ? code.callingCode[0]
                  : ctrl.contact.person.contact.primaryCode;
              ctrl.contact.person.contact.homeCode =
                ctrl.contact.person.contact.home === ''
                  ? code.callingCode[0]
                  : ctrl.contact.person.contact.homeCode;
              ctrl.contact.person.contact.workCode =
                ctrl.contact.person.contact.work === ''
                  ? code.callingCode[0]
                  : ctrl.contact.person.contact.workCode;
            }
          }
        }
        ctrl.saveContact();
      };

      /*
       * Get Location
       * --------------------------------------------------------------------------------
       */
      ctrl.getLocation = () => {
        const countryOfResidency = ctrl.contact.isCompany
          ? ctrl?.contact?.company?.information?.countryOfResidency
          : ctrl?.contact?.person?.information?.countryOfResidency;
        const country = _.find(ctrl.countries, (c) => countryOfResidency === c?.name?.common);
        if (country !== undefined) {
          return country.cca2;
        }
        return ctrl.currentOrganization.organization.location &&
          ctrl?.currentOrganization?.organization?.location?.cca2
          ? ctrl?.currentOrganization?.organization?.location?.cca2
          : '';
      };

      /*
       * Copy Contact Current Address
       * --------------------------------------------------------------------------------
       */
      ctrl.copyCurrentAddress = ($event, isSettlement, isRegistered) => {
        $event.stopPropagation();
        const currentAddress = ctrl.contact?.isCompany
          ? angular.copy(ctrl.contact?.company?.contact?.address || Address.blank())
          : angular.copy(ctrl.contact?.person?.contact?.address || Address.blank());
        if (ctrl.contact?.isCompany) {
          if (!isRegistered) {
            ctrl.copyAddress(currentAddress, 'company', 'mailingAddress', true);
          } else {
            ctrl.copyAddress(currentAddress, 'company', 'registeredAddress', true);
          }
        } else if (!isSettlement) {
          ctrl.copyAddress(currentAddress, 'person', 'mailingAddress', true);
        } else {
          ctrl.copyAddress(currentAddress, 'person', 'settlementAddress', true);
        }
      };

      ctrl.toggleCurrentAddressFrom = () => {
        if (
          !ctrl.contact.isCompany &&
          !ctrl.contact.isDateOfCurrentAddressLessThanThreeYears()
        ) {
          ctrl.contact.person.contact.previousAddress = Address.blank();
        }
        ctrl.saveContact();
      };

      ctrl.changeCurrentAddress = () => {
        const currentAddress = ctrl.contact?.isCompany
          ? angular.copy(ctrl.contact?.company?.contact?.address || Address.blank())
          : angular.copy(ctrl.contact?.person?.contact?.address || Address.blank());
        if (ctrl.contact?.isCompany) {
          if (
            ctrl.contact?.company?.contact?.mailingAddress?.idLinkedAddress &&
            ctrl.contact?.company?.contact?.mailingAddress?.idLinkedAddress ===
              currentAddress.id
          ) {
            ctrl.copyAddress(currentAddress, 'company', 'mailingAddress', true);
          } else {
            ctrl.saveContact();
          }
        } else {
          ctrl.addOwnerOccupiedAsset();
          if (
            ctrl.contact?.person?.contact?.mailingAddress?.idLinkedAddress &&
            ctrl.contact?.person?.contact?.mailingAddress?.idLinkedAddress === currentAddress.id
          ) {
            ctrl.copyAddress(currentAddress, 'person', 'mailingAddress', true);
          }
          if (
            ctrl.contact?.person?.contact?.settlementAddress?.idLinkedAddress &&
            ctrl.contact?.person?.contact?.settlementAddress?.idLinkedAddress ===
              currentAddress.id
          ) {
            ctrl.copyAddress(currentAddress, 'person', 'settlementAddress', true);
          }
          if (
            !ctrl.contact?.person?.contact?.mailingAddress.idLinkedAddress ||
            (ctrl.contact?.person?.contact?.mailingAddress.idLinkedAddress &&
              ctrl.contact?.person?.contact?.mailingAddress?.idLinkedAddress !==
                currentAddress.id) ||
            !ctrl.contact?.person?.contact?.settlementAddress?.idLinkedAddress ||
            (ctrl.contact?.person?.contact?.settlementAddress?.idLinkedAddress &&
              ctrl.contact?.person?.contact?.settlementAddress?.idLinkedAddress !==
                currentAddress.id)
          ) {
            ctrl.saveContact();
          }
        }
      };

      ctrl.changeOtherAddress = (isSettlement) => {
        if (ctrl.contact.isCompany) {
          ctrl.contact.company.contact.mailingAddress.idLinkedAddress = '';
        } else if (!isSettlement) {
          ctrl.contact.person.contact.mailingAddress.idLinkedAddress = '';
        } else {
          ctrl.contact.person.contact.settlementAddress.idLinkedAddress = '';
        }
        ctrl.saveContact();
      };

      ctrl.copySpouseCurrentAddress = ($event) => {
        $event.stopPropagation();
        ctrl.contact.person.contact.housing =
          ctrl.spouseContact?.person?.contact?.housing ||
          ctrl.availableContactResidentialStatusOptions[0];
        const spouseCurrentAddress =
          ctrl.spouseContact?.person?.contact?.address || Address.blank();

        ctrl.copyAddress(spouseCurrentAddress, 'person', 'address', true);
        ctrl.addOwnerOccupiedAsset();
      };

      ctrl.copyAddress = (copyAddress, contactType, addressType) => {
        if (!ctrl.contact[contactType].contact[addressType]) {
          uiService.toast({
            text: {
              p1: 'There was an',
              p2: 'error',
              p3: 'copying address'
            },
            warn: true
          });
          return;
        }

        ctrl.contact[contactType].contact[addressType] = Address.copy(copyAddress);

        ctrl.saveContact();
      };

      ctrl.resetLinkedAddress = (currentAddress) => {
        const address = currentAddress;
        address.idLinkedAddress = '';
        ctrl.saveContact();
      };

      ctrl.toggleMailingAddressPostOfficeBox = () => {
        if (ctrl.contact?.isCompany) {
          const isPostOfficeBoxEnabled =
            ctrl.contact?.company?.contact?.mailingAddress?.isPostOfficeBoxEnabled || false;
          ctrl.contact.company.contact.mailingAddress = Address.blank();
          ctrl.contact.company.contact.mailingAddress.isPostOfficeBoxEnabled =
            isPostOfficeBoxEnabled;
        } else {
          const isPostOfficeBoxEnabled =
            ctrl.contact?.person?.contact?.mailingAddress?.isPostOfficeBoxEnabled || false;
          ctrl.contact.person.contact.mailingAddress = Address.blank();
          ctrl.contact.person.contact.mailingAddress.isPostOfficeBoxEnabled =
            isPostOfficeBoxEnabled;
        }
        ctrl.saveContact();
      };

      /*
       * Adding Contact as Spouse
       * --------------------------------------------------------------------------------
       */
      ctrl.setSpouseContacts = () => {
        const blank = [
          { id: 'new', value: 'Create new contact' },
          { id: 'existing', value: 'Search existing contact' }
        ];
        const idContacts = _.map(ctrl.personContacts, (c) => c.id);
        const contacts = _.filter(
          ctrl.personContacts,
          (c) =>
            !c.person.information.idSpouse ||
            idContacts.indexOf(c.person.information.idSpouse) > -1
        );
        for (let c = 0; c < contacts.length; c += 1) {
          ctrl.spouseContacts.push({ id: contacts[c].id, value: contacts[c].getName() });
        }
        ctrl.spouseContacts = ctrl.spouseContacts.concat(blank);
      };

      ctrl.removeCurrentContact = (idContact) => (item) => {
        if (item.id === idContact) {
          return false;
        }
        return true;
      };

      ctrl.getSpouse = () => {
        if (!ctrl.contact.isCompany) {
          ctrl.spouseContact = _.find(
            ctrl.personContacts || [],
            (spouse) => spouse?.id === ctrl.contact?.person?.information?.idSpouse
          );
          ctrl.showSpouseWarnings();
        }
      };

      ctrl.showMaritalStatusWarning = () =>
        !ctrl.contact?.person?.information?.idSpouse &&
        (ctrl.contact?.person?.information?.maritalStatus?.name ===
          ContactMaritalStatusOption.Married.name ||
          ctrl.contact?.person?.information?.maritalStatus?.name ===
            ContactMaritalStatusOption.DeFacto.name);

      ctrl.showSpouseWarnings = () => {
        if (
          ctrl.contact?.person?.information?.idSpouse &&
          isUUID(ctrl.contact?.person?.information?.useExistingContactAsSpouse) &&
          _.indexOf(ctrl.personContacts || [], ctrl.contact?.person?.information?.idSpouse) ===
            -1
        ) {
          contactService
            .readContact({ id: ctrl.contact?.person?.information?.idSpouse })
            .then((contact) => {
              if (!contact) {
                ctrl.isSpouseDeleted = true;
              } else {
                ctrl.isSpouseInactive = !contact?.isActive;
              }
            });
        }
      };

      ctrl.toggleSpouse = () => {
        if (ctrl.contact.person.information.idSpouse) {
          const pIdx = _.findIndex(
            ctrl.personContacts || [],
            (c) => c?.id === ctrl.contact?.person?.information?.idSpouse
          );
          if (pIdx > -1) {
            const spouse = ctrl.personContacts[pIdx];
            const cIdx = _.findIndex(ctrl.contacts || [], (c) => c?.id === spouse?.id);
            if (cIdx > -1) {
              spouse.person.information.maritalStatus =
                ctrl.contact.person.information.maritalStatus;
              spouse.person.information.idSpouse = '';
              spouse.person.information.spouseFirstName = '';
              spouse.person.information.spouseFamilyName = '';
              spouse.person.information.useExistingContactAsSpouse = '';
              ctrl.contacts[cIdx] = spouse;
              ctrl.personContacts[pIdx] = spouse;
            } else {
              ctrl.personContacts.splice(pIdx, 1);
            }
          }
          contactService
            .readContact({
              id: ctrl.contact.person.information.idSpouse
            })
            .then((result) => {
              if (result) {
                contactService.updateContact({
                  id: result.id,
                  isCompany: false,
                  person: {
                    information: {
                      firstName: result.person.information.firstName,
                      familyName: result.person.information.familyName,
                      idSpouse: '',
                      spouseFirstName: '',
                      spouseFamilyName: '',
                      useExistingContactAsSpouse: ''
                    }
                  }
                });
              }
              ctrl.contact.person.information.idSpouse = '';
              ctrl.contact.person.information.spouseFirstName = '';
              ctrl.contact.person.information.spouseFamilyName = '';
              ctrl.contact.person.information.useExistingContactAsSpouse = '';
              ctrl.getSpouse();
              ctrl.saveContact();
            });
        } else {
          ctrl.saveContact();
        }
      };

      ctrl.toggleMaritalStatus = () => {
        if (
          ctrl.contact?.person?.information?.maritalStatus?.name !==
            ContactMaritalStatusOption.Married.name &&
          ctrl.contact?.person?.information?.maritalStatus?.name !==
            ContactMaritalStatusOption.DeFacto.name
        ) {
          ctrl.toggleSpouse();
        } else {
          ctrl.saveContact();
        }
      };

      ctrl.contactSpouseAdded = (contact, spouse) => {
        ctrl.contact = contact;
        const cIdx = _.findIndex(ctrl.contacts || [], (c) => c?.id === spouse?.id);
        if (cIdx > -1) {
          ctrl.contacts[cIdx] = spouse;
        }
        const pIdx = _.findIndex(ctrl.personContacts || [], (c) => c?.id === spouse?.id);
        if (pIdx > -1) {
          ctrl.personContacts[pIdx] = spouse;
        } else {
          ctrl.personContacts.push(spouse);
        }
        ctrl.getSpouse();
        ctrl.saveContact();
      };

      /*
       * Dependent
       * --------------------------------------------------------------------------------
       */
      ctrl.setDependentDate = () => {
        if (ctrl?.contact?.person?.information?.dependents?.length) {
          ctrl.contact.person.information.dependents.forEach((_, idx) => {
            dateTimeService.getSet(
              ctrl,
              ctrl.contact,
              `person.information.dependents[${idx}].dateOfBirth`,
              `getSetDependentDateOfBirth${idx}`
            );
          });
        }
      };

      ctrl.toggleDependents = () => {
        if (!ctrl.contact.person.information.dependents) {
          ctrl.contact.person.information.dependents = [];
        }
        const nOD = ctrl.contact.person.information.numberOfDependents;
        if (nOD !== '') {
          const dLen = ctrl.contact.person.information.dependents.length;
          const len = nOD > dLen ? nOD - dLen : dLen - nOD;
          for (let d = 0; d < len; d += 1) {
            if (nOD > dLen) {
              ctrl.contact.person.information.dependents.push(Dependent.blank());
              ctrl.setDependentDate();
            } else {
              const idx = d !== 0 ? dLen - 1 - d : dLen - 1;
              ctrl.contact.person.information.dependents.splice(idx, 1);
            }
          }
        } else {
          ctrl.contact.person.information.dependents = [];
        }
        ctrl.saveContact();
      };

      ctrl.getAgeOfDependent = (dependent) => helperService.getAgeOfDependent({ dependent });

      /*
       * Add asset if residential status of contact's current address set up on own
       * --------------------------------------------------------------------------------
       */
      ctrl.addOwnerOccupiedAsset = () => {
        if (
          !ctrl.contact?.isCompany &&
          (ctrl.contact?.person?.contact?.housing?.name ===
            ContactResidentialStatusOption.own.name ||
            ctrl.contact?.person?.contact?.housing?.name ===
              ContactResidentialStatusOption.own_home_mortgage.name)
        ) {
          if (ctrl.isFactFind) {
            const idx = _.findIndex(
              ctrl.ticket?.assets || [],
              (a) =>
                helperService.isAssetTypeOwnerOccupied(a?.assetType) &&
                (a?.address?.formatted === ctrl?.contact?.person?.contact?.address?.formatted ||
                  (a?.address?.street === ctrl?.contact?.person?.contact?.address?.street &&
                    a?.address?.streetNumber ===
                      ctrl?.contact?.person?.contact?.address?.streetNumber &&
                    (a.address.suburb === ctrl.contact.person.contact.address.suburb ||
                      a.address.city === ctrl.contact.person.contact.address.city) &&
                    a?.address?.postCode === ctrl?.contact?.person?.contact?.address?.postCode))
            );
            if (idx === -1) {
              const ownership = helperService.setOwnershipOfAssetOrLiability(
                ctrl.contacts,
                false
              );
              const asset = Asset.blank(ctrl.availableAssetTypes[0], ownership);
              const oIdx = _.findIndex(
                asset?.ownership || [],
                (o) => o?.idContact === ctrl.contact?.id
              );
              asset.ownership[oIdx].percent = 100;
              asset.address = ctrl.contact?.person?.contact?.address || Address.blank();
              ctrl.ticket.assets.push(asset);
              const data = {
                assets: ctrl.ticket.assets
              };
              ctrl.onAssetFinished({ data });
            } else if (
              ctrl.contact?.person?.information?.idSpouse &&
              ctrl.contact?.person?.information?.idSpouse !== '' &&
              _.indexOf(ctrl.idClients || [], ctrl.contact?.person?.information?.idSpouse) > -1
            ) {
              for (let o = 0; o < ctrl.ticket.assets[idx]?.ownership?.length; o += 1) {
                if (ctrl.ticket?.assets[idx]?.ownership[o]?.idContact === ctrl.contact?.id) {
                  ctrl.ticket.assets[idx].ownership[o].percent = 50;
                }
                if (
                  ctrl.ticket?.assets[idx]?.ownership[o]?.idContact ===
                  ctrl.contact?.person?.information?.idSpouse
                ) {
                  ctrl.ticket.assets[idx].ownership[o].percent = 50;
                }
              }
              const data = {
                assets: ctrl.ticket.assets
              };
              ctrl.onAssetFinished({ data });
            }
          } else {
            let idx = -1;
            if (ctrl.contact.assets && ctrl.contact.assets.length) {
              idx = ctrl.contact.assets.findIndex(
                (a) =>
                  helperService.isAssetTypeOwnerOccupied(a.assetType) &&
                  (a.address.formatted === ctrl.contact.person.contact.address.formatted ||
                    (a.address.street === ctrl.contact.person.contact.address.street &&
                      a.address.streetNumber ===
                        ctrl.contact.person.contact.address.streetNumber &&
                      (a.address.suburb === ctrl.contact.person.contact.address.suburb ||
                        a.address.city === ctrl.contact.person.contact.address.city) &&
                      a.address.postCode === ctrl.contact.person.contact.address.postCode))
              );
            }
            if (idx === -1) {
              const ownership = helperService.setOwnershipOfAssetOrLiability(
                [ctrl.contact],
                true
              );
              const asset = Asset.blank(ctrl.availableAssetTypes[0], ownership);
              asset.address = ctrl.contact.person.contact.address;
              ctrl.contact.assets.push(asset);
              ctrl.onAssetFinished({ assets: ctrl.contact.assets });
            }
          }
        }
        ctrl.saveContact();
      };

      /*
       * Search Company Name and Abn
       * --------------------------------------------------------------------------------
       */
      ctrl.lookupByBusinessNumberNZ = async (num) => NZBNLookupService.byNZBN({ query: num });
      ctrl.lookupByBusinessNumberAU = async (num) => {
        if (isACN(num)) {
          return ABNLookupService.byACN({ query: num });
        }
        if (isABN(num)) {
          return ABNLookupService.byABN({ query: num });
        }
        return [];
      };
      ctrl.lookupByNameNZ = async (params) => NZBNLookupService.byName(params);
      ctrl.lookupByNameAU = async (params) => ABNLookupService.byName(params);

      ctrl.searchTermNameChange = (searchTerm, isTrust) => {
        if (!ctrl.isSelectedItemNameChange) {
          if (isTrust) {
            ctrl.contact.company.information.trustName = searchTerm;
          } else {
            ctrl.contact.company.information.name = searchTerm;
          }
          ctrl.saveContact();
        }
      };

      ctrl.selectedItemNameChange = (selectedItem, isTrust) => {
        if (_.isObject(selectedItem)) {
          if (isTrust) {
            ctrl.isSelectedItemNameChange = true;
            if (ctrl.currentOrganization?.organization?.location?.cca2 === 'NZ') {
              ctrl.contact.company.information.trustName = selectedItem.name;
              ctrl.contact.company.information.trustRefNumber = selectedItem.nzbn;
            }
            if (ctrl.currentOrganization?.organization?.location?.cca2 === 'AU') {
              ctrl.contact.company.information.trustName = selectedItem.Name;
              ctrl.contact.company.information.trustRefNumber = selectedItem.Abn;
            }
            ctrl.saveContact();
          } else {
            ctrl.isSelectedItemNameChange = true;
            if (ctrl.currentOrganization?.organization?.location?.cca2 === 'NZ') {
              ctrl.contact.company.information.name =
                selectedItem && _.isObject(selectedItem) ? selectedItem.name : selectedItem;
              ctrl
                .lookupByBusinessNumberNZ(selectedItem.nzbn)
                .then((res) =>
                  ctrl.getSetMoreDetailsAboutCompany(_.isArray(res) ? res[0] : res)
                );
            }
            if (ctrl.currentOrganization?.organization?.location?.cca2 === 'AU') {
              ctrl.contact.company.information.name =
                selectedItem && _.isObject(selectedItem) ? selectedItem.Name : selectedItem;
              ctrl.lookupByBusinessNumberAU(selectedItem.Abn).then((res) => {
                ctrl.getSetMoreDetailsAboutCompany(_.isArray(res) ? res[0] : res);
              });
            }
          }
        }
      };

      ctrl.searchTermBusinessNumberChange = (searchTerm, isTrust) => {
        if (isTrust) {
          ctrl.contact.company.information.trustRefNumber = searchTerm;
        } else {
          ctrl.contact.company.information.refNumber = searchTerm;
        }
        ctrl.saveContact();
      };

      ctrl.selectedItemBusinessIdentifierChange = (selectedItem, isTrust) => {
        if (_.isObject(selectedItem)) {
          if (isTrust) {
            ctrl.contact.company.information.trustName =
              selectedItem?.mainName?.organisationName ||
              selectedItem?.businessName?.organisationName ||
              selectedItem?.name ||
              `${selectedItem?.legalName?.givenName} ${selectedItem?.legalName?.familyName}` ||
              '';
            ctrl.contact.company.information.trustRefNumber =
              selectedItem?.abn ||
              selectedItem?.acn ||
              selectedItem?.nzbn ||
              selectedItem?.ABN?.identifierValue ||
              selectedItem?.ASICNumber ||
              '';
            ctrl.saveContact();
          } else {
            ctrl.getSetMoreDetailsAboutCompany(selectedItem);
          }
        }
      };

      ctrl.getSetMoreDetailsAboutCompany = (item) => {
        if (ctrl.currentOrganization?.organization?.location?.cca2 === 'NZ') {
          ctrl.contact.company.information.name =
            item?.mainName?.organisationName || item?.businessName?.organisationName || '';
          ctrl.contact.company.information.refNumber = item?.nzbn || '';
          ctrl.contact.company.information.businessType =
            item?.entityType?.entityTypeDescription;

          if (item?.mainName?.effectiveFrom || item?.businessName?.effectiveFrom) {
            const epoch = parseInt(
              moment
                .utc(item?.mainName?.effectiveFrom || item?.businessName?.effectiveFrom, 'X')
                .format('X'),
              10
            );
            ctrl.contact.company.information.incorporated = epoch;
            ctrl.contact.company.information.dateOfRegistration = epoch;
            ctrl.getSetIncorporated(
              moment
                .utc(ctrl.contact.company.information.incorporated, 'X')
                .format('YYYY-MM-DD')
            );
            ctrl.getSetDateOfRegistration(
              moment
                .utc(ctrl.contact.company.information.dateOfRegistration, 'X')
                .format('YYYY-MM-DD')
            );
          } else {
            ctrl.contact.company.information.incorporated = 0;
            ctrl.getSetIncorporated(null);

            ctrl.contact.company.information.dateOfRegistration = 0;
            ctrl.getSetDateOfRegistration(null);
          }

          ctrl.contact.company.information.stateOfRegistration =
            item?.mainBusinessPhysicalAddress?.stateCode || '';
          ctrl.contact.company.information.typeOfBusinessEntity =
            ContactCompanyType[item?.entityType?.entityTypeCode?.toLowerCase()] ||
            ContactCompanyType.none;

          ctrl.toggleTypeOfBusinessEntity();
          return;
        }

        ctrl.contact.company.information.name =
          item?.mainName?.organisationName ||
          `${item?.legalName?.givenName} ${item?.legalName?.familyName}` ||
          '';
        ctrl.contact.company.information.refNumber =
          item?.ABN?.identifierValue || item?.ASICNumber || '';
        ctrl.contact.company.information.tradingName =
          item?.mainTradingName?.organisationName || '';

        if (item?.mainName?.effectiveFrom || item?.mainTradingName?.effectiveFrom) {
          ctrl.contact.company.information.incorporated = parseInt(
            moment
              .utc(item?.mainName?.effectiveFrom || item?.mainTradingName?.effectiveFrom)
              .format('X') || 0,
            10
          );
          ctrl.getSetIncorporated(
            moment.utc(ctrl.contact.company.information.incorporated, 'X').format('YYYY-MM-DD')
          );
        } else {
          ctrl.contact.company.information.incorporated = 0;
          ctrl.getSetIncorporated(null);
        }

        if (item?.mainTradingName?.effectiveFrom || item?.mainName?.effectiveFrom) {
          ctrl.contact.company.information.dateOfRegistration = parseInt(
            moment
              .utc(item?.mainTradingName?.effectiveFrom || item?.mainName?.effectiveFrom)
              .format('X') || 0,
            10
          );
          ctrl.getSetDateOfRegistration(
            moment
              .utc(ctrl.contact.company.information.dateOfRegistration, 'X')
              .format('YYYY-MM-DD')
          );
        } else {
          ctrl.contact.company.information.dateOfRegistration = 0;
          ctrl.getSetDateOfRegistration(null);
        }

        ctrl.contact.company.information.isVatRegistered =
          !!item?.goodsAndServicesTax?.effectiveFrom;
        ctrl.contact.company.information.stateOfRegistration =
          item?.mainBusinessPhysicalAddress?.stateCode || '';
        ctrl.contact.company.information.typeOfBusinessEntity =
          ContactCompanyType[item?.typeOfBusinessEntity?.name] || ContactCompanyType.none;
        if (item?.goodsAndServicesTax?.effectiveFrom) {
          ctrl.contact.company.information.vatRegisteredDate =
            moment.utc(item?.goodsAndServicesTax?.effectiveFrom).format('X') || 0;
          ctrl.getSetVatRegisteredDate(
            moment
              .utc(ctrl.contact.company.information.vatRegisteredDate, 'X')
              .format('YYYY-MM-DD')
          );
          ctrl.contact.company.information.isVatRegistered = true;
        }
        ctrl.toggleTypeOfBusinessEntity();
      };

      ctrl.toggleGstVatRegistered = () => {
        if (!ctrl.contact?.company?.information?.isVatRegistered) {
          ctrl.contact.company.information.vatRegisteredDate = 0;
          ctrl.getSetVatRegisteredDate(null);
        }
        ctrl.saveContact();
      };

      ctrl.searchIndustryCodes = (query) => {
        const lowercaseQuery = String(query).toLowerCase();
        return _.filter(
          ctrl.industries,
          (industry) =>
            industry.id.toString().indexOf(lowercaseQuery) !== -1 ||
            industry.value.toLowerCase().indexOf(lowercaseQuery) !== -1
        );
      };

      /*
       * Add/Remove Company Individuals
       * --------------------------------------------------------------------------------
       */
      ctrl.getCompanyIndividualTitle = (idx) => {
        let title = `Entity individual #${idx + 1}`;
        switch (ctrl.contact?.company?.information?.typeOfBusinessEntity?.name) {
          case ContactCompanyType.sole_proprietor.name:
            title = 'Proprietor details';
            break;
          case ContactCompanyType.partnership.name:
            title = `Partner #${idx + 1}`;
            break;
          case ContactCompanyType.individual_trustee.name:
            title = 'Trustee details';
            break;
          case ContactCompanyType.joint_trustee.name:
            title = `Trustee #${idx + 1}`;
            break;
          default:
            break;
        }
        return title;
      };

      ctrl.toggleTypeOfBusinessEntity = () => {
        ctrl.contact.company.information.individuals = [];
        ctrl.contact.company.information.individuals.push(CompanyIndividual.blank());
        let country = '';
        if (
          ctrl.contact.company.information.countryOfResidency &&
          ctrl.contact.company.information.countryOfResidency !== ''
        ) {
          country = ctrl.contact.company.information.countryOfResidency;
        }
        country =
          ctrl.currentOrganization.organization.location.name.common &&
          ctrl.currentOrganization.organization.location.name.common !== ''
            ? ctrl.currentOrganization.organization.location.name.common
            : '';
        if (
          ctrl.contact?.company?.information?.typeOfBusinessEntity?.name ===
            ContactCompanyType.sole_proprietor.name ||
          ctrl.contact?.company?.information?.typeOfBusinessEntity?.name ===
            ContactCompanyType.individual_trustee.name
        ) {
          const name = ctrl.contact.company.information.name.split(' ');
          const firstPart = name[0];
          const otherParts = ctrl.contact.company.information.name.substr(
            ctrl.contact.company.information.name.indexOf(' ') + 1
          );
          ctrl.contact.company.information.individuals[0].firstName = firstPart;
          ctrl.contact.company.information.individuals[0].familyName = otherParts;
        }
        if (country !== '') {
          const code = _.find(ctrl.countries, (c) => c.name && c.name.common === country);
          ctrl.contact.company.information.individuals[0].phoneCode =
            code !== undefined ? code.callingCode[0] : '';
        }
        ctrl.saveContact();
      };

      ctrl.companyIndividualAdd = ($event) => {
        $event.stopPropagation();
        ctrl.contact.company.information.individuals.push(CompanyIndividual.blank());
      };

      ctrl.companyIndividualDelete = ($event, idx) => {
        $event.stopPropagation();
        ctrl.contact.company.information.individuals.splice(idx, 1);
        ctrl.saveContact();
      };

      ctrl.toggleActingOnBehalfOfATrust = () => {
        if (!ctrl.contact.company.information.isActingOnBehalfTrust) {
          ctrl.contact.company.information.trustName = '';
          ctrl.contact.company.information.trustStructure = ContactCompanyTrustStructure.none;
          ctrl.contact.company.information.trustRefNumber = '';
          ctrl.contact.company.information.settlor = '';
        }
        ctrl.saveContact();
      };

      /*
       * Add/Remove Employment
       * --------------------------------------------------------------------------------
       */
      ctrl.employmentAdd = ($event) => {
        if ($event) {
          $event.stopPropagation();
        }
        const lastIdx = ctrl?.contact?.person?.employments?.length
          ? ctrl.contact.person.employments.length - 1
          : 0;
        if (lastIdx > -1) {
          const lastEmploymentHasType =
            lastIdx > 0
              ? ctrl.contact.person.employments[lastIdx].type &&
                ctrl.contact.person.employments[lastIdx].startDate
              : true;
          if (lastEmploymentHasType) {
            ctrl.contact.person.employments.push(Employment.blank(true));
          }
        }
      };

      ctrl.isStartDateOfEmploymentLessThanThreeYears = () =>
        _.some(ctrl.contact.person.employments, (e) =>
          e.startDate
            ? moment.utc().diff(moment.utc(e.startDate, 'X').toDate(), 'days') > 1095
            : false
        );

      ctrl.employmentDelete = ($event, idEmployment) => {
        $event.stopPropagation();
        const idx = _.findIndex(ctrl.contact.person.employments, (e) => e.id === idEmployment);
        if (idx > -1) {
          ctrl.contact.person.employments.splice(idx, 1);
          ctrl.saveContact();
        }
      };

      ctrl.employmentTypeToggled = (employment, isEmployed) => {
        if (isEmployed) {
          const incomeType =
            employment?.type?.name === ContactEmploymentType.salaried_employee.name
              ? ctrl.incomeTypesAvailable[0]
              : ctrl.incomeTypesAvailable[1];
          ctrl.incomeAdd(incomeType, ctrl.contact.id, employment.id);
        } else {
          for (let i = 0; i < ctrl.ticket.income.length; i += 1) {
            const income = ctrl.ticket.income[i];
            if (income.idContact === ctrl.contact.id && income.idEmployer === employment.id) {
              ctrl.incomeDelete(i);
            }
          }
        }
        ctrl.saveEmployment(employment);
      };

      ctrl.employmentStartDateChanged = () => {
        ctrl.contact.person.employments.push(Employment.blank(false));
        ctrl.saveContact();
      };

      ctrl.incomeAdd = (incomeType, idContact, idEmployer) => {
        ctrl.ticket.income = incomeService.incomeAdd(
          ctrl.ticket.income,
          incomeType,
          idContact,
          idEmployer
        );
        ctrl.saveIncome();
      };

      ctrl.incomeDelete = (idx) => {
        ctrl.ticket.income = incomeService.incomeDelete(ctrl.ticket.income, idx);
        ctrl.saveIncome();
      };

      ctrl.saveEmployment = (employment) => {
        const idx = _.findIndex(ctrl.contact.person.employments, (e) => e.id === employment.id);
        if (idx > -1) {
          ctrl.contact.person.employments[idx] = employment;
          ctrl.isStartDateOfEmploymentLessThanThreeYears();
          ctrl.saveContact();
        }
      };

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      /*
       * Save contact
       * --------------------------------------------------------------------------------
       */
      ctrl.saveContact = _.debounce(() => {
        ctrl.setDiversificationOpportunities();
        ctrl.onFinished({ contact: ctrl.contact });
      }, 1500);

      /*
       * Save income
       * --------------------------------------------------------------------------------
       */
      ctrl.saveIncome = _.debounce(() => {
        const data = {
          income: ctrl.ticket.income
        };
        ctrl.onIncomeFinished({ data });
      }, 1500);

      /*
       * Save diversification opportunities
       * --------------------------------------------------------------------------------
       */
      ctrl.saveDiversificationOpportunities = (diversificationOpportunities) => {
        if (ctrl.isReady === true) {
          ctrl.onDiversificationFinished({ diversificationOpportunities });
        }
      };

      ctrl.saveDiversificationIntegration = (integration, result) => {
        if (ctrl.isReady === true) {
          ctrl.onDiversificationIntegrationFinished({ integration, result });
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
